import '../styles/Banner.css'


function Banner() {
    return (
        <div id='banner'>
            <div id='banner-title'>
          <h1>
                    Elliot GUIBERTEAU
                    </h1>
            </div>
            <div id='banner-menu'>
                <ul>
                    <li>
                        <a href="#welcome">
                    Accueil
                    </a>
                    </li>
                <li>
                <a href="#profile">
                    À propos
                    </a>
                </li>
                <li>
                    <a href="#portfolio">
                    Mes réalisations
                    </a>
                </li>
                <li>
                     <a href="#footer">
                    Contact
                    </a>
                </li>
                </ul>
            </div>
        </div>
    )
}

export default Banner